import React from "react";

const SvgGreetings = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 18 24"
    fill="currentColor"
    {...props}
  >
    <defs>
      <path id="greetings_svg__a" d="M0 .752h17.016V24H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(0 -.752)">
        <mask id="greetings_svg__b" fill="#fff">
          <use xlinkHref="#greetings_svg__a" />
        </mask>
        <path
          fill="#091E42"
          d="M15.016 21.78L2 19.18V6.674l13.016 2.6V21.78zM12.215 6.676l-7.11-1.42L12.218 3.1l-.002 3.576zm3.997.8l-1.998-.4.004-5.323a1 1 0 0 0-1.29-.958L.71 4.498a1 1 0 0 0-.297.16c-.014.011-.033.013-.047.024l-.002.003a.996.996 0 0 0-.253.324c-.02.04-.024.082-.038.123a.99.99 0 0 0-.062.275C.01 5.424 0 5.44 0 5.455V20a1 1 0 0 0 .805.98l15.015 3a1 1 0 0 0 1.196-.98V8.455a1 1 0 0 0-.804-.98z"
          mask="url(#greetings_svg__b)"
        />
      </g>
      <path
        fill="#091E42"
        d="M7.447 11.532c.207 0 .356.16.427.31a1 1 0 0 0 1.808 0c.071-.15.221-.31.427-.31.273 0 .495.27.495.598a.687.687 0 0 1-.065.297L8.723 14.55l-1.729-2.179a.714.714 0 0 1-.042-.24c0-.33.222-.599.495-.599m-2.095 1.986l2.558 3.225a1 1 0 0 0 .765.38h.02c.291 0 .568-.129.758-.35l2.594-3.032c.054-.054.104-.115.148-.183.268-.424.41-.917.41-1.428 0-1.432-1.12-2.598-2.496-2.598a2.4 2.4 0 0 0-1.33.401 2.403 2.403 0 0 0-1.332-.4c-1.376 0-2.495 1.165-2.495 2.597 0 .43.102.853.295 1.226.03.057.065.112.105.162"
      />
    </g>
  </svg>
);

export default SvgGreetings;
